import { CustomizableLayout } from "~/types/CustomizableLayout";

export const FP_INPUT_CLASSNAME =
    "bg-white text-black hover:border-[#E0413B] font-tiempos border-none rounded-lg focus:border-[#E0413B] hover:bg-white focus:bg-white focus:ring-whitelabel-freepress-tertiary";

export const DEFAULT_FP_CUSTOMIZATION: CustomizableLayout = {
    labelClassName: "text-black font-american-grotesk-condensed",
    descriptionClassName: "text-black/70 font-tiempos",
    linkClassName:
        "text-black group-hover:text-whitelabel-freepress-button-primary hover:text-whitelabel-freepress-button-primary font-american-grotesk font-normal shadow-none",
    buttons: {
        default:
            " bg-whitelabel-freepress-button-primary font-american-grotesk text-white",
        secondary:
            "bg-white font-american-grotesk text-black hover:bg-whitelabel-freepress-button-primary hover:text-white hover:border-none hover:ring-0",
        destructive:
            "bg-whitelabel-freepress-button-destructive font-american-grotesk text-white hover:bg-whitelabel-freepress-button-destructive/80",
    },
    inputClassName: FP_INPUT_CLASSNAME,
    inputLabelClassName: "text-black font-tiempos",
    mainCardClassName: "bg-whitelabel-freepress-secondary",
    secondaryCardClassName: "bg-whitelabel-freepress-tertiary",
    defaultTheme: "light",
    selectInput: {
        inputClassName: FP_INPUT_CLASSNAME,
        listClassName: "bg-white text-black",
        itemClassName:
            " text-black w-full bg-white aria-selected:text-white aria-selected:bg-white-label-freepress-tertiary hover:bg-whitelabel-freepress-tertiary focus:bg-whitelabel-freepress-tertiary",
    },
};
